import React from 'react';
import { Button, Typography, ScreenContainer, ContentFrame, LayoutContent, LayoutControls, } from '@pinwheel/origami';
import { useOpts } from '../../context';
import SuccessAnimation from '../../components/SuccessAnimation';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import ModalHeader from '../../components/ModalHeader';
var CardError = function () {
    var getLocalizedString = useGetLocalizedString();
    var _a = useOpts(), linkTokenPayload = _a.linkTokenPayload, exit = _a.exit;
    var title = getLocalizedString('DIRECT_DEPOSIT_UPDATED');
    var subtitle = getLocalizedString('DIRECT_DEPOSIT_UPDATED_AND_WILL');
    var buttonLabel = getLocalizedString('CLOSE');
    var cardErrorText = getLocalizedString('COULDNT_UPDATE_CARD', [
        linkTokenPayload.card.cardName,
    ]);
    return (React.createElement(ScreenContainer, { "data-testid": "CardError" },
        React.createElement(ModalHeader, { hideBackButton: true, hideExitButton: true }),
        React.createElement(ContentFrame, null,
            React.createElement(LayoutContent, { sx: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'column',
                } },
                React.createElement(SuccessAnimation, null),
                React.createElement(Typography, { align: "center", variant: "header", as: "h2" }, title),
                React.createElement(Typography, { align: "center", sx: { margin: '8px 0' }, variant: "body", as: "h3" }, subtitle),
                React.createElement(Typography, { align: "center", sx: { margin: '8px 0' }, variant: "caption" }, cardErrorText)),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { eventId: "CardError-exit", dataTestId: "button", onClick: function () { return exit(); } }, buttonLabel)))));
};
export default CardError;
